import styled from "styled-components";
import { ColorV2 } from "config/colors";
import { TypographyV2 } from "config/font";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 16px;
`;

export const Title = styled.h1`
  ${TypographyV2.h5}
  color: ${ColorV2.Blue1};
  margin: 0;
`;

export const Controls = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
`;

export const DateNav = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const DateLabel = styled.span`
  ${TypographyV2.b2}
  color: ${ColorV2.Blue1};
  min-width: 80px;
  text-align: center;
`;

export const QuickButtons = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const DatePickerWrapper = styled.div`
  width: 168px;

  /* Suppress the bottom message/hint space the DatePicker reserves by default */
  > div {
    margin-bottom: 0;
  }
`;

export const CardsGrid = styled.div`
  display: grid;
  width: 100%;
  grid-template-columns: repeat(6, 1fr);
  gap: 16px;
`;

export const DragHandle = styled.div`
  position: absolute;
  top: 10px;
  right: 12px;
  width: 10px;
  height: 14px;
  background-image: radial-gradient(
    circle,
    ${ColorV2.Blue5} 1.5px,
    transparent 1.5px
  );
  background-size: 5px 5px;
  opacity: 0;
  transition: opacity 0.15s;
  pointer-events: none;
`;

export const StatCard = styled.div<{
  $isDragging: boolean;
  $dropIndicator: "left" | "right" | null;
}>`
  min-width: 0;
  position: relative;
  background: ${ColorV2.White};
  border: 1.5px solid ${ColorV2.Blue5};
  border-radius: 16px;
  padding: 20px 24px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  opacity: ${({ $isDragging }) => ($isDragging ? 0.4 : 1)};
  cursor: grab;
  transition: opacity 0.15s;

  &:active {
    cursor: grabbing;
  }

  &:hover ${DragHandle} {
    opacity: 1;
  }

  &::before,
  &::after {
    content: "";
    position: absolute;
    top: 4px;
    bottom: 4px;
    width: 3px;
    border-radius: 2px;
    background: ${ColorV2.ElectricBlue};
    pointer-events: none;
  }

  &::before {
    left: -9px;
    opacity: ${({ $dropIndicator }) => ($dropIndicator === "left" ? 1 : 0)};
  }

  &::after {
    right: -9px;
    opacity: ${({ $dropIndicator }) => ($dropIndicator === "right" ? 1 : 0)};
  }
`;

export const CardLabel = styled.span`
  ${TypographyV2.s1}
  color: ${ColorV2.Blue4};
`;

export const CardValue = styled.span`
  ${TypographyV2.h3}
  color: ${ColorV2.Blue1};
`;

export const CardLoader = styled.div`
  display: flex;
  align-items: center;
  min-height: 36px;
`;

export const ManageLink = styled.button`
  ${TypographyV2.s1}
  color: ${ColorV2.ElectricBlue};
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  text-align: left;
  margin-top: 2px;

  &:hover {
    text-decoration: underline;
  }
`;
